export * from './Catalog';
export * from './Student';


// WEBPACK FOOTER //
// ./src/common/modules/core/models/index.ts